export class MachineFormValues {

    _licensePlate; // string
    _state; // boolean
    _brand; // string
    _model; // string
    _description; // string
    _outsource; // SelectOption[]
    _contractorId; // number
    _contractorSchema; // SelectOption[]

    constructor(
        licensePlate,
        state,
        brand,
        model,
        description,
        outsource,
        contractorId,
        contractorSchema,
    ) {
        this._licensePlate = licensePlate;
        this._state = state;
        this._brand = brand;
        this._model = model;
        this._description = description;
        this._outsource = outsource;
        this._contractorId = contractorId;
        this._contractorSchema = contractorSchema;
    }

    static null() {
        return new this(
            '',
            false,
            '',
            '',
            '',
            [],
            -1,
            [],
        );
    }

    static fromMachine(machine, currentContractorId) {
        const outsource = machine.company();
        const documentation = machine.documentation();
        const mySchema = documentation.mySchema();
        const myDocumentSchema = mySchema.documentSchema();

        return new this(
            machine.licensePlate(),
            machine.isActive(),
            machine.brand(),
            machine.model(),
            machine.description(),
            [
                {
                    label: outsource.description(),
                    value: outsource.id(),
                    item: outsource,
                },
            ],
            currentContractorId,
            myDocumentSchema.id() === -1
                ? []
                : [
                    {
                        label: myDocumentSchema.description(),
                        value: myDocumentSchema.id(),
                        item: myDocumentSchema,
                    },
                ],
        );
    }

    initialValues() {
        return {
            licensePlate: this._licensePlate,
            state: this._state,
            brand: this._brand,
            model: this._model,
            description: this._description,
            outsource: this._outsource,
            contractorId: this._contractorId,
            contractorSchema: this._contractorSchema,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/form/MachineFormValues.js